import Uebersicht from "./uebersicht/Uebersicht";
import GeraeteManagement from "./geraetemanagement/GeraeteManagement";
import { Wertelisten } from "./administration/werteliste/Werteliste";
import Netzwirtschaft from "./netzwirtschaft/Netzwirtschaft";
import Messstellen from "./administration/messstellen/Messstellen";
import Router from "./administration/routergeraet/Routergeraet";
import { Messgeraete } from "./administration/messgeraete/Messgeraete";
import Gruppenverwaltung from "./pqereignisse/gruppenverwaltung/Gruppenverwaltung";
import PQEreignisse from "./pqereignisse/PQEreignisse";
import { Netzereignisse } from "./administration/netzereignisse/Netzereignisse";
import Gruppen from "./pqereignisse/gruppen/Gruppen";
import Betriebsereignisse from "./betriebsereignisse/Betriebsereignisse";
import { Datenfluss } from "./datenfluss/Datenfluss";
import Stoerungsmanagement from "./stoerungsmanagement/Stoerungsmanagement";
import Datenvollstaendigkeit from "./datenvollstaendigkeit/Datenvollstaendigkeit";
import { Datenplausibilitaet } from "./datenplausibilitaet/Datenplausibilitaet";
import Filter from "../features/filter/Filter";
import pqIndex from "./analyse/pqIndex/PqIndex";
import Korrelation from "./analyse/korrelation/Korrelation";
import LambdaControl from "./administration/lambdacontrol/lambdacontrol";
import Anomalie from "./analyse/anomalie/Anomalie";
import { rollen } from "../utils/auth/authConfig";
import Trends from "./analyse/trends/Trends";
import Hilfe from "./hilfe/Hilfe";
import Datenabruf from "./administration/datenabruf/Datenabruf";
import Firewallantrag from "./administration/firewallantrag/Firewallantrag";
import { IpVerwaltungGrid } from "./administration/ipVerwaltung/IpVerwaltung";

export const routes = [
  {
    name: "Übersicht",
    component: Uebersicht,
    path: "/uebersicht",
    showInMenu: true,
    roles: [rollen.everyone],
    items: [
      {
        name: "PQ-Übersicht",
        component: Uebersicht,
        path: "/uebersicht",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "PQ-Ereignisse",
        component: PQEreignisse,
        path: "/uebersicht/pqereignisse",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Gruppen",
        component: Gruppen,
        path: "/uebersicht/gruppen",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Gruppenverwaltung",
        component: Gruppenverwaltung,
        path: "/uebersicht/gruppenverwaltung",
        showInMenu: true,
        roles: [rollen.everyone],
      },
    ],
  },
  {
    name: "Geräteverwaltung",
    component: GeraeteManagement,
    path: "/geraeteverwaltung",
    showInMenu: true,
    roles: [rollen.everyone],
    items: [
      {
        name: "Aktive Messpunkte",
        component: GeraeteManagement,
        path: "/geraeteverwaltung/aktivemesspunkte",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Messstellen",
        component: Messstellen,
        path: "/geraeteverwaltung/messstellen",
        params: "/:id?",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Messgeräte",
        component: Messgeraete,
        path: "/geraeteverwaltung/messgeraete",
        params: "/:id?",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Router",
        component: Router,
        path: "/geraeteverwaltung/router",
        params: "/:id?",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Betriebsereignisse",
        component: Betriebsereignisse,
        path: "/geraeteverwaltung/betriebsereignisse",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Übersicht Datenfluss",
        component: Datenfluss,
        path: "/geraeteverwaltung/datenfluss",
        showInMenu: false,
        roles: [rollen.everyone],
      },
      {
        name: "IP-Verwaltung",
        component: IpVerwaltungGrid,
        showInMenu: true,
        path: "/geraeteverwaltung/ipverwaltung",
        roles: [rollen.everyone],
      },
    ],
  },
  {
    name: "Dashboard Analyse",
    component: Netzwirtschaft,
    path: "/dashboardAnalyse",
    showInMenu: true,
    roles: [rollen.everyone],
  },
  {
    name: "Netzereignisse",
    component: Netzereignisse,
    path: "/netzereignisse",
    params: "/:id?",
    showInMenu: true,
    roles: [rollen.everyone],
  },
  {
    name: "Störungsmanagement",
    component: Stoerungsmanagement,
    path: "/stoerungsmanagement",
    params: "/:id?",
    showInMenu: true,
    roles: [rollen.everyone],
  },
  {
    name: "Administration",
    component: Wertelisten,
    showInMenu: true,
    path: "/administration",
    roles: [rollen.everyone],
    items: [
      {
        name: "Stammdaten",
        component: Wertelisten,
        showInMenu: true,
        path: "/administration/stammdaten",
        roles: [rollen.everyone],
      },
      {
        name: "Datenvollständigkeit",
        component: Datenvollstaendigkeit,
        path: "/administration/datenvollstaendigkeit",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Datenplausibilität",
        component: Datenplausibilitaet,
        path: "/administration/datenplausibilitaet",
        showInMenu: true,
        roles: [rollen.everyone],
      },
      {
        name: "Datenabruf",
        component: Datenabruf,
        showInMenu: true,
        path: "/administration/datenabruf",
        roles: [rollen.backend],
      },
      {
        name: "Lambda control",
        component: LambdaControl,
        path: "/administration/lambdacontrol",
        showInMenu: true,
        roles: [rollen.backend],
      },
    ],
  },
  {
    name: "Filter",
    component: Filter,
    path: "/filter",
    showInMenu: false,
    roles: [rollen.everyone],
  },
  {
    name: "Analyse",
    component: pqIndex,
    showInMenu: process.env.REACT_APP_ENVIRONMENT != "Prod",
    path: "/analyse",
    roles: [rollen.everyone],
    items: [
      {
        name: "PQ Index",
        component: pqIndex,
        path: "/analyse/pqindex",
        showInMenu: process.env.REACT_APP_ENVIRONMENT != "Prod",
        roles: [rollen.everyone],
      },
      {
        name: "Korrelation",
        component: Korrelation,
        path: "/analyse/korrelation",
        params: "/:id?",
        showInMenu: process.env.REACT_APP_ENVIRONMENT != "Prod",
        roles: [rollen.everyone],
      },
      {
        name: "Anomalie",
        component: Anomalie,
        path: "/analyse/anomalie",
        showInMenu: process.env.REACT_APP_ENVIRONMENT != "Prod",
        roles: [rollen.everyone],
      },
      {
        name: "Trends",
        component: Trends,
        path: "/analyse/trends",
        showInMenu: process.env.REACT_APP_ENVIRONMENT != "Prod",
        roles: [rollen.everyone],
      },
    ],
  },
  {
    name: "Hilfe",
    component: Hilfe,
    path: "/hilfe",
    showInMenu: false,
    roles: [rollen.everyone],
  },
];
